import { useMe } from '@/hooks/queries/useMe'
import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/unverified')({
  component: RouteComponent,
  staticData: {
    title: 'Unverified',
    crumb: 'Unverified',
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})

function RouteComponent() {
  const { data: me } = useMe()
  const navigate = useNavigate()

  if (!me) return null

  if (me.permissions.length > 0) {
    navigate({ to: '/welcome' })
  }

  return <Outlet />
}
